/* eslint-disable camelcase */
import { useContext, useRef, ReactNode } from 'react';
import { TrackContext } from './AnalyticsContext';
import useTrackModal from '../../hooks/useTrackModal';
import useConditionalProps from '../../hooks/useConditionalProps';
import useTrackPage from '../../hooks/useTrackPage';
import useTrackComponentInteraction from '../../hooks/useTrackComponentInteraction';

export interface TrackProviderProps {
  trackEvent?: any;
  pageEventName?: any;
  eventParams?: object;
  isModal?: boolean;
  isVisible?: boolean;
  directProps?: any;
  source_page?: string;
  source_page_section?: string;
  section?: string;
  page_type?: string | 'modal';
  component_name?: string;
  index?: number;
  page_name?: string;
  button_type?: string;
  button_name?: string;
  button_copy?: any;
  component_detail?: string | number;
  component_id?: string | number;
  value?: string | number;
  link_type?: string;
  link_name?: string;
  link_copy?: string;
  form_email?: string;
  children?: ReactNode;
  style?: any;
}

export function TrackProvider({
  trackEvent = null,
  pageEventName = null,
  eventParams = {},
  isModal = false,
  isVisible = false,
  children,
  source_page,
  source_page_section,
  section,
  page_type,
  component_name,
  index,
  page_name,
  button_type,
  button_name,
  button_copy,
  component_detail,
  component_id,
  value,
  link_type,
  link_name,
  link_copy,
  form_email,
  style,
  ...directProps
}: TrackProviderProps) {
  const previousProps = useContext(TrackContext);
  const componentRef = useRef(null);

  const props = useConditionalProps({
    directProps,
    source_page,
    source_page_section,
    section,
    page_type,
    component_name,
    index,
    page_name,
    button_type,
    button_name,
    button_copy,
    component_detail,
    component_id,
    value,
    link_type,
    link_name,
    link_copy,
    form_email,
  });

  const allProps: any = { ...previousProps, ...props };

  useTrackPage({
    pageEventName,
    eventParams,
    props,
  });

  useTrackModal({
    isVisible,
    allProps,
    isModal,
  });

  useTrackComponentInteraction({
    trackEvent,
    allProps,
    eventParams,
    componentRef,
  });

  const childrenComponent = ['component_interaction', 'restaurant_impression'].includes(
    trackEvent
  ) ? (
    <div ref={componentRef} style={style}>
      {children}
    </div>
  ) : (
    children
  );

  return (
    <TrackContext.Consumer>
      {(consumedProps) => {
        const combinedProps = { ...consumedProps, ...props };
        return (
          <TrackContext.Provider value={combinedProps}>{childrenComponent}</TrackContext.Provider>
        );
      }}
    </TrackContext.Consumer>
  );
}
